import React from "react";
import { Grid, Icon, Label } from "semantic-ui-react";
import MainButton from "components/Buttons/MainButton";
import { displayGender } from "utils/displayGender";
import displayName from "utils/displayName";
import moment from "moment";
import { isMobile } from "utils/isMobile";

const _appointmentContainer = (prescription, folder, user, isUrgent) => {
	let backgroundColor = "#fff";
	if (prescription?.assigned_secretary && prescription?.assigned_secretary.id !== user.session.id && folder.openedBy?.id !== user.session.id)
		backgroundColor = "#DFDFDF";
	else if (isUrgent) {
		backgroundColor = "rgba(255, 80, 77,0.4)";
	} else if (folder.validation_paused) {
		const pausedTime = moment().diff(folder.validation_paused_at, "hours");
		if (pausedTime > 1) backgroundColor = "rgb(255,0,0,0.25)";
		else if (pausedTime > 0) backgroundColor = "rgb(255,165,0.25)";
		else backgroundColor = "rgb(0,128,0,0.25)";
	}
	return {
		backgroundColor: backgroundColor,
		width: "100%",
		position: "relative",
		padding: 10,
		display: "flex",
		borderRadius: "0",
		marginTop: "5px",
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		alignItems: "center",
		marginRight: 10,
		marginLeft: 10,
	};
};

const ExpressListItem = ({ express, generalParameters, handleOnPress, onPressText = "Voir", user }) => {
	const getAnalysesString = (presc) => {
		let analyses = [];
		let analysesStr = "";
		if (presc?.analyses)
			presc.analyses.forEach((ana) => {
				if (!analyses.includes(ana.properties.code)) analyses.push(ana.properties.code);
			});

		analyses.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));

		analysesStr = analyses.reduce((a, b) => a.concat(b + ", "), "");
		analysesStr = analysesStr.substr(0, analysesStr.length - 2);

		return analysesStr;
	};

	const prescription = express.folder.prescriptions ? express.folder.prescriptions[0] : null;
	const isUrgent = express.folder.prescriptions?.findIndex((prescri) => prescri.urgent) > -1;

	return (
		<Grid.Row style={_appointmentContainer(prescription, express.folder, user, isUrgent)} key={`folder-${express.folder?.id}`}>
			<Grid.Column mobile={16} tablet={5} computer={5} style={{ paddingLeft: 20 }}>
				{express.folder.patient && express.folder.patient.id !== +process.env.REACT_APP_USER_TO_CHANGE && (
					<div style={{ paddingLeft: 20, position: "relative" }}>
						<b>
							{displayGender(prescription?.patient ?? express.folder.patient, generalParameters.data)}
							{displayName(prescription?.patient ?? express.folder.patient)}
						</b>
						<br />
						<span style={{ fontSize: "0.8em" }}>CNS: {prescription?.patient?.cns ?? express.folder.patient?.cns}</span>
						<br />
						<span style={{ fontSize: "0.8em", fontStyle: "italic" }}>
							{moment().diff(prescription?.patient?.birth_date ?? express.folder.patient?.birth_date, "years")} ans
						</span>
					</div>
				)}
				{express.folder.patient && express.folder.patient.id === +process.env.REACT_APP_USER_TO_CHANGE && (
					<div style={{ paddingLeft: 20, position: "relative" }}>Patient à associer</div>
				)}
			</Grid.Column>

			<Grid.Column mobile={16} tablet={4} computer={4} style={{ width: "30%", marginTop: isMobile() ? 10 : 0 }}>
				<div>
					<b style={{ fontSize: "0.8em" }}>
						Dossier {express.folder.code}
						{express.folder.date ? ` - ${moment(express.folder.date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}` : ""}
					</b>
					<br />
					{express.folder.labAppointment && express.folder.labAppointment.center && <span>{express.folder.labAppointment.center.name}</span>}
					<br />
					<span style={{ fontSize: "0.7em" }}>{getAnalysesString(prescription)}</span>
					<br />
					{!express.barcodes && <Label color="red">Pas de code-barres associés</Label>}
					{express.barcodes && !express.docsAssociated && (
						<Label color="grey">En attente de document {express.barcodes && ` (${Object.keys(JSON.parse(express.barcodes)).length})`}</Label>
					)}
					{express.barcodes && express.docsAssociated && JSON.parse(express.docsAssociated).length > 0 && (
						<Label color="green">
							Documents associés : {JSON.parse(express.docsAssociated).length}/{express.barcodes && Object.keys(JSON.parse(express.barcodes)).length}
						</Label>
					)}
					<br />
					{express.folder.status === "PENDING" && express.folder.paused_at && (
						<>
							<Icon name="wait" style={{ color: "#b9c503" }} />
							{`Dossier en attente depuis le ${moment(express.folder.paused_at).format(
								`${process.env.REACT_APP_DATE_DISPLAY_FORMAT} [à] ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`
							)}`}
						</>
					)}
				</div>
			</Grid.Column>

			<Grid.Column mobile={16} tablet={4} computer={4} style={{ width: "30%", marginTop: isMobile() ? 10 : 0 }}>
				{express.folder.validation_paused && (
					<>
						<Icon name="wait" style={{ color: "#b9c503" }} />
						<span>Validation en pause</span>
						<br />
						<span>
							{moment(express.folder.validation_paused_at).format(
								`${process.env.REACT_APP_DATE_DISPLAY_FORMAT} - ${process.env.REACT_APP_TIME_DISPLAY_FORMAT}`
							)}{" "}
							- {express.folder.validation_paused_by?.last_name} {express.folder.validation_paused_by?.first_name}
						</span>
						<br />
						{express.folder.validation_paused_reason && <span>Motif: {express.folder.validation_paused_reason}</span>}
					</>
				)}
				{!express.folder.validation_paused &&
					prescription?.assigned_secretary &&
					express.folder.openedBy?.id !== user.session.id &&
					prescription?.assigned_secretary.id !== user.session.id && (
						<div>Secrétaire: {`${prescription?.assigned_secretary.last_name} ${prescription?.assigned_secretary.first_name}`}</div>
					)}
				{isUrgent && (
					<div>
						<Icon name="warning" style={{ color: "#ff0000" }} />
						Dossier urgent
					</div>
				)}
				{express.folder.openedBy && (
					<div>
						Ouvert par {express.folder.openedBy.last_name} {express.folder.openedBy.first_name}
					</div>
				)}
			</Grid.Column>

			<Grid.Column mobile={16} tablet={3} computer={3} style={{ width: "20%", textAlign: "right" }}>
				<MainButton
					text={onPressText}
					onClick={(e) => {
						if (e !== undefined) e.preventDefault();
						handleOnPress();
					}}
				/>
			</Grid.Column>
		</Grid.Row>
	);
};

export default ExpressListItem;
